import { Icons } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { HistoryDto, PatientBasicsDto } from '../../../api/generated/model';
import { DashedButton } from '../../../components/DashedButtonStyled.tsx';
import { HistoryEntry } from './HistoryEntry.tsx';

export function HistoryTherapyFinished({ history, patient }: { history: HistoryDto; patient: PatientBasicsDto }) {
  const navigate = useNavigate();
  return (
    <HistoryEntry history={history} subject={'Therapie von'} action={'wurde beendet'} patient={patient}>
      <DashedButton
        endDecorator={<Icons.ArrowForward />}
        color={'neutral'}
        sx={{ alignSelf: 'start' }}
        onClick={() => navigate({ to: '/patients/$patientId/therapy', params: { patientId: history.patientId } })}>
        Zur Therapie
      </DashedButton>
    </HistoryEntry>
  );
}
